import deCommon from './locales/de/common.json';
import deDesign from './locales/de/design.json';
import dePages from './locales/de/pages.json';
import deShell from './locales/de/shell.json';
import enAnalytics from './locales/en/analytics.json';
import enAuth from './locales/en/auth.json';
import enCommon from './locales/en/common.json';
import enDesign from './locales/en/design.json';
import enLanding from './locales/en/landing.json';
import enPages from './locales/en/pages.json';
import enProjects from './locales/en/projects.json';
import enShell from './locales/en/shell.json';
import esCommon from './locales/es/common.json';
import esDesign from './locales/es/design.json';
import esPages from './locales/es/pages.json';
import esShell from './locales/es/shell.json';
import frAnalytics from './locales/fr/analytics.json';
import frAuth from './locales/fr/auth.json';
import frCommon from './locales/fr/common.json';
import frDesign from './locales/fr/design.json';
import frLanding from './locales/fr/landing.json';
import frPages from './locales/fr/pages.json';
import frProjects from './locales/fr/projects.json';
import frShell from './locales/fr/shell.json';
import nlAnalytics from './locales/nl/analytics.json';
import nlAuth from './locales/nl/auth.json';
import nlCommon from './locales/nl/common.json';
import nlDesign from './locales/nl/design.json';
import nlLanding from './locales/nl/landing.json';
import nlPages from './locales/nl/pages.json';
import nlProjects from './locales/nl/projects.json';
import nlShell from './locales/nl/shell.json';
import ptCommon from './locales/pt/common.json';
import ptDesign from './locales/pt/design.json';
import ptPages from './locales/pt/pages.json';
import ptShell from './locales/pt/shell.json';

export const namespaces = [
  'common',
  'auth',
  'landing',
  'projects',
  'analytics',
  'design',
  'shell',
  'pages',
] as const;
export type Namespace = (typeof namespaces)[number];

export const defaultNS = 'common' satisfies Namespace;

/*
 * Locales: EN (default / fallback), FR, NL fully translated; DE/ES/PT carry the
 * shell-level namespaces (common, design, shell) — the remaining page namespaces
 * fall back to English (fallbackLng) until they are imported per page from the
 * CLD mockup translations.
 */
export const resources = {
  en: {
    common: enCommon,
    auth: enAuth,
    landing: enLanding,
    projects: enProjects,
    analytics: enAnalytics,
    design: enDesign,
    shell: enShell,
    pages: enPages,
  },
  fr: {
    common: frCommon,
    auth: frAuth,
    landing: frLanding,
    projects: frProjects,
    analytics: frAnalytics,
    design: frDesign,
    shell: frShell,
    pages: frPages,
  },
  nl: {
    common: nlCommon,
    auth: nlAuth,
    landing: nlLanding,
    projects: nlProjects,
    analytics: nlAnalytics,
    design: nlDesign,
    shell: nlShell,
    pages: nlPages,
  },
  de: {
    common: deCommon,
    design: deDesign,
    shell: deShell,
    pages: dePages,
  },
  es: {
    common: esCommon,
    design: esDesign,
    shell: esShell,
    pages: esPages,
  },
  pt: {
    common: ptCommon,
    design: ptDesign,
    shell: ptShell,
    pages: ptPages,
  },
} as const;

export type Resources = typeof resources;
